import { module } from './store'
import { createModule } from '@vue-storefront/core/lib/module'

export const KEY = 'transport'
export const Transport = createModule({
  key: KEY,
  store: { modules: [{ key: KEY, module }] }
})
